export const mergeArrays = (firstArray, secondArray) => {
    const newSet = new Set([...firstArray, ...secondArray]);
    return Array.from(newSet);
};
